import Avatar from "@mui/material/Avatar"
import AvatarGroup from "@mui/material/AvatarGroup"
import ListItem from "@mui/material/ListItem/ListItem"
import Skeleton from "@mui/material/Skeleton"
import Typography from "@mui/material/Typography"
import useTheme from "@mui/material/styles/useTheme"
import useMediaQuery from "@mui/material/useMediaQuery"
import { memo } from "preact/compat"
import { identity, times } from "ramda"
import { isNull } from "./TitleField"
import type { PollPhenomenon } from "./poll"

export const AvatarBar = memo(function AvatarBar({
  poll: { ballots, title },
}: {
  poll: PollPhenomenon
}) {
  const theme = useTheme()
  const smallScreen = useMediaQuery(theme.breakpoints.down("sm"))
  const MaxAvatars = smallScreen ? 2 : 6

  return (
    <ListItem>
      <Typography variant="h6">Combined Ranking: </Typography>
      <AvatarGroup
        max={MaxAvatars}
        // @ts-ignore "total" is definitely a real thing
        total={Object.keys(ballots).length}
        sx={{ marginLeft: "auto" }}
      >
        {(isNull(title)
          ? times(identity, MaxAvatars)
          : Object.keys(ballots)
        ).map((id) =>
          isNull(title) ? (
            <Skeleton variant="circular">
              <Avatar />
            </Skeleton>
          ) : (
            <Avatar
              alt="an indistinguishable voter"
              src={`https://robohash.org/${id}.png?bgset=bg1`}
              onClick={() => console.error( "UNIMPLEMENTED: Avatar") }
            />
          ),
        )}
      </AvatarGroup>
    </ListItem>
  )
})
